module.exports = __webpack_public_path__ + "img/pg-logo.f8b032ae.svg";